import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ 
      background: 'var(--bg-light)',
      borderTop: '1px solid var(--border-medium)',
      marginTop: '80px'
    }}>
      <div className="container" style={{ 
        maxWidth: '1440px',
        padding: '64px 24px 32px'
      }}>
        {/* Main Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '48px'
        }}>
          {/* Company Info */}
          <div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: '600',
              color: 'var(--brand-primary)',
              marginBottom: '16px'
            }}>
              Munoret
            </h3>
            <p style={{
              color: 'var(--text-secondary)',
              marginBottom: '24px',
              lineHeight: '1.6'
            }}>
              Your trusted partner in talent acquisition and workforce solutions.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="#" style={{
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                <Linkedin size={24} />
              </a>
              <a href="#" style={{
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                <Twitter size={24} />
              </a>
              <a href="#" style={{
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                <Facebook size={24} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: 'var(--text-primary)',
              marginBottom: '16px'
            }}>
              Quick Links
            </h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                { to: '/', label: 'Home' },
                { to: '/services', label: 'Services' },
                { to: '/about', label: 'About Us' },
                { to: '/careers', label: 'Careers' },
                { to: '/newsletters', label: 'Newsletters' },
                { to: '/contact', label: 'Contact' }
              ].map((link) => (
                <li key={link.to} style={{ marginBottom: '12px' }}>
                  <Link
                    to={link.to}
                    style={{
                      textDecoration: 'none',
                      color: 'var(--text-secondary)',
                      transition: 'color 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: 'var(--text-primary)',
              marginBottom: '16px'
            }}>
              Our Services
            </h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                'Executive Search',
                'Permanent Placement',
                'Temporary Staffing',
                'Contract Staffing',
                'RPO Solutions'
              ].map((service) => (
                <li key={service} style={{ 
                  marginBottom: '12px',
                  color: 'var(--text-secondary)'
                }}>
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: 'var(--text-primary)',
              marginBottom: '16px'
            }}>
              Contact Us
            </h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                color: 'var(--text-secondary)'
              }}>
                <Mail size={20} />
                <a href="mailto:info@munoret.com" style={{
                  textDecoration: 'none',
                  color: 'var(--text-secondary)'
                }}>
                  info@munoret.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid var(--border-medium)',
          paddingTop: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p style={{ color: 'var(--text-caption)', fontSize: '14px' }}>
            © 2025 Munoret. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <a href="#" style={{
              textDecoration: 'none',
              color: 'var(--text-caption)',
              fontSize: '14px',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
            onMouseLeave={(e) => e.target.style.color = 'var(--text-caption)'}
            >
              Privacy Policy
            </a>
            <a href="#" style={{
              textDecoration: 'none',
              color: 'var(--text-caption)',
              fontSize: '14px',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
            onMouseLeave={(e) => e.target.style.color = 'var(--text-caption)'}
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
